// Global variables
let productIdStr = "";
let isAsyncGetPrefFinished = false;
let availableDates = [];
let storedValue = localStorage.getItem("myAreaValue");
let availableDeliveryDates = [];

const calendarOptions = {
	enableTime: false,
	dateFormat: "Y/m/d",
	locale: "ja",
	disableMobile: true,
	minDate: "today",
	disable: []
};

// Element references (initialized in initializeElements)
let shippingAreaSelect = null;
let prefLoadingMessage = null;
let shippingCalendar = null;
let originalDateSelect = null;
let shippingPeriodError = null;
let originalDateSelectOptions = null;
let variantDateSelectWrap = null;
let loadingImage = null;
let deliveryDateInput = null;
let receiveDateInput = null;

// --- Utility Functions ---
async function fetchWithRetry(url, options, maxRetries = 3) {
	for (let i = 0; i < maxRetries; i++) {
		try {
			const response = await fetch(url, options);
			if (!response.ok) { // Check for any non-2xx status
                let errorBody = 'Could not read error body';
                try {
                    errorBody = await response.text();
                } catch (e) {
                    console.error("Error reading error response body:", e); // Keep error log
                }
				throw new Error(`HTTP error! status: ${response.status}, body: ${errorBody}`);
			}
			return response;
		} catch (error) {
			console.error(`Fetch attempt ${i+1} failed:`, error); // Keep error log
			if (i === maxRetries - 1) throw error; // Throw the last error
			// const delay = Math.pow(2, i) * 1000; // 1s, 2s, 4s
			// await new Promise(resolve => setTimeout(resolve, delay));
		}
	}
    // This should theoretically not be reached if maxRetries > 0
    throw new Error('Max retries reached without success or specific error.');
}

function parseDate(dateString) {
    if (!dateString) return null;
	const parts = dateString.split(/[-/]/).map(part => Number.parseInt(part, 10));
	if (parts.length === 3 && !Number.isNaN(parts[0]) && !Number.isNaN(parts[1]) && !Number.isNaN(parts[2])) {
        if (parts[0] < 1970 || parts[0] > 2100) return null;
		return new Date(parts[0], parts[1] - 1, parts[2]);
	}
	return null;
}
function removeTimeFromDate(date) {
    if (!(date instanceof Date) || Number.isNaN(date.getTime())) return null;
	return new Date(date.getFullYear(), date.getMonth(), date.getDate());
}
function parseAndRemoveTimeFromDate(dateString) {
	if (!dateString) return null;
	const parsedDate = parseDate(dateString);
    if (!parsedDate) return null;
	return removeTimeFromDate(parsedDate);
}
function extractDate(dateString) {
    if (!dateString) return null;
	const regex = /(\d{4})年(\d{1,2})月(\d{1,2})日/;
	const matches = dateString.match(regex);
	if (matches && matches.length === 4) {
		const year = Number.parseInt(matches[1], 10);
		const month = Number.parseInt(matches[2], 10);
		const day = Number.parseInt(matches[3], 10);
		if (!Number.isNaN(year) && !Number.isNaN(month) && !Number.isNaN(day)) {
            if (month < 1 || month > 12 || day < 1 || day > 31) return null;
			return new Date(year, month - 1, day);
		}
	}
	return null;
}
function addLeadingZero(num) {
	return num < 10 ? `0${num}` : String(num);
}
function convertDate(dateString) {
    if (!dateString) return "";
	const matches = dateString.match(/(\d{4})年(\d{1,2})月(\d{1,2})日/);
	if (!matches) return "";
	const year = matches[1];
	const month = matches[2];
	const day = matches[3];
	const dateObj = new Date(year, parseInt(month, 10) - 1, day);
    if (isNaN(dateObj.getTime())) return "";
	return `${dateObj.getFullYear()}/${addLeadingZero(dateObj.getMonth() + 1)}/${addLeadingZero(dateObj.getDate())}`;
}

function formatDateToJapanese(dateString) {
    if (!dateString) return "";
    const parts = dateString.split('/');
    if (parts.length === 3) {
        const year = parts[0];
        const month = parts[1].padStart(2, '0');
        const day = parts[2].padStart(2, '0');
        return `${year}年${month}月${day}日`;
    }
    return dateString; // Fallback in case of unexpected format
}
// --- End Utility Functions ---


// DOM element initialization function
function initializeElements() {
	shippingAreaSelect = document.querySelector('#shippingAreaSelect');
	prefLoadingMessage = document.querySelector('div#pref-loading-message');
	shippingCalendar = document.querySelector('#shipping-calendar');
	originalDateSelect = document.getElementById("originalDateSelect");
	shippingPeriodError = document.getElementById('shipping-period-error');
	originalDateSelectOptions = document.querySelectorAll("#originalDateSelect select option");
	variantDateSelectWrap = document.getElementById("variant-date-select-wrap");
	loadingImage = document.getElementById('loading-image');
	deliveryDateInput = document.querySelector('input[name="properties[お届け予定日]"]');
	receiveDateInput = document.querySelector('input[name="properties[受取日]"]');

	// console.log('Elements initialized:', { // Remove initialization log
	// 	shippingAreaSelect: !!shippingAreaSelect,
	// 	prefLoadingMessage: !!prefLoadingMessage,
	// 	shippingCalendar: !!shippingCalendar
	// });
}

// DOMContentLoaded event listener
document.addEventListener('DOMContentLoaded', () => {
	// console.log('DOM fully loaded, initializing delivery date functionality'); // Remove DOM loaded log
	initializeElements();

	// Check for shippingAreaSelect only if NOT takeout
    const isTakeoutInitial = window.productMeta?.is_takeout === true || window.productMeta?.is_takeout === 'true';
	if (!isTakeoutInitial && !shippingAreaSelect) {
		// console.warn('Shipping area select not found on initial load, setting up retry'); // Remove warning
		const checkForElement = setInterval(() => {
			// console.log('Attempting to initialize elements'); // Remove retry log
			initializeElements();
			if (shippingAreaSelect) {
				// console.log('Found shipping area select, proceeding with initialization'); // Remove success log
				clearInterval(checkForElement);
				setupInitialState();
			}
		}, 100);
		setTimeout(() => {
			clearInterval(checkForElement);
			// if (!shippingAreaSelect) { // Remove give up warning
			//     console.warn('Gave up waiting for shipping area select element');
			// }
		}, 5000);
	} else {
		// console.log('Shipping area select found or not needed (takeout), proceeding with initialization'); // Remove log
		setupInitialState();
	}
});

// Initial state setup
function setupInitialState() {
	if (typeof window.productMeta === 'undefined') {
		window.productMeta = { is_takeout: false, is_managed_by_variant_shipping_date: true };
		// console.warn('window.productMeta was undefined, initialized with defaults.'); // Remove warning
	} else {
        window.productMeta.is_takeout = window.productMeta.is_takeout === true || window.productMeta.is_takeout === 'true';
    }

	initializeCalendar(); // Initialize calendar structure

	const productId = window.location.pathname.match(/\/products\/([^\/?]+)/)?.[1] || '';
	if (productId) {
		// console.log('Product ID found:', productId); // Remove log
		getProductId().then(idStr => {
            productIdStr = idStr;
			if (productIdStr && !window.productMeta.is_takeout) {
				getPref(productIdStr).catch(error => {
					console.error('Error fetching prefecture data:', error); // Keep error
				});
			} else if (window.productMeta.is_takeout) {
                // console.log('Takeout product, skipping prefecture fetch.'); // Remove log
                whenShippingAreaSelect(); // Trigger calendar logic directly for takeout
            }
		}).catch(error => {
			console.error('Error getting product ID:', error); // Keep error
		});
	// } else { // Remove log
        // console.log('No product ID found in URL');
    }

	if (!window.productMeta.is_takeout) {
	    enableSelect(); // Setup shipping select if needed
	}
	setupCustomOptionListeners(); // Setup listeners for custom options unrelated to date

	if (shippingAreaSelect && !window.productMeta.is_takeout) {
		shippingAreaSelect.addEventListener('change', async (event) => {
			// console.log('Shipping area select changed:', event.target.value); // Remove log
            const selectedValue = event.target.value; // 選択された値を取得
            if (selectedValue && selectedValue !== "0") {
                localStorage.setItem("myAreaValue", selectedValue); // ★★★ 選択された値をlocalStorageに保存 ★★★
                // console.log('Saved selected prefecture to localStorage:', selectedValue); // デバッグ用ログ（必要に応じて）
            } else {
                localStorage.removeItem("myAreaValue"); // デフォルトが選択された場合は削除
                // console.log('Removed prefecture from localStorage (default selected)'); // デバッグ用ログ（必要に応じて）
            }
			const hasShippingDate = window.productMeta?.has_shipping_date === true || window.productMeta?.has_shipping_date === 'true';
			if (hasShippingDate) {
				await whenShippingAreaSelect();
			}
		});
	}
}


const dateOnlyShippablePeriodFrom = (() => { try { return parseAndRemoveTimeFromDate(window.productMeta?.shippable_period_from); } catch (e) { return null; } })();
const dateOnlyShippablePeriodTo = (() => { try { return parseAndRemoveTimeFromDate(window.productMeta?.shippable_period_to); } catch (e) { return null; } })();

let isManagedByVariantShippingDate = window.productMeta?.is_managed_by_variant_shipping_date !== false; // Default true if undefined or true

// --- Core Logic Functions ---

// カートボタンの有効化を制御する関数
function updateCartButtonState() {
    const hasShippingDate = window.productMeta?.has_shipping_date === true || window.productMeta?.has_shipping_date === "true";
    const isTakeout = window.productMeta?.is_takeout === true || window.productMeta?.is_takeout === "true";
    const areaSelected = window.areaSelected;
    const selectedDate = window.selectedDate;
    
    // カスタムオプション（スライス枚数）の選択状態を確認
    const customOptionSelect = document.querySelector('select[name^="properties[スライス枚数]"]');
    const isCustomOptionSelected = customOptionSelect ? customOptionSelect.value && customOptionSelect.value !== '選択してください' : true;
    
    // 配送日指定が無しの場合、在庫があれば常に有効（ただしカスタムオプションは必須）
    if (!hasShippingDate) {
        if (isCustomOptionSelected) {
            window.dispatchEvent(new CustomEvent('enable-cart-button'));
        } else {
            window.dispatchEvent(new CustomEvent('disable-cart-button'));
        }
        return;
    }
    
    // 配送日指定ありの場合、従来のロジックを適用（カスタムオプションも必須）
    if ((isTakeout || (areaSelected && selectedDate)) && isCustomOptionSelected) {
        window.dispatchEvent(new CustomEvent('enable-cart-button'));
    } else {
        window.dispatchEvent(new CustomEvent('disable-cart-button'));
    }
}

// 日付が選択された時の処理 (flatpickr onChange)
function changeDate(selectedDates, dateStr, instance) {
	if (!dateStr) return;
	try {
		const matchingDeliveryDate = availableDeliveryDates?.find(option => {
			if (option?.delivery_date && /^\d{8}$/.test(option.delivery_date)) {
				const year = option.delivery_date.substring(0, 4);
				const month = option.delivery_date.substring(4, 6);
				const day = option.delivery_date.substring(6, 8);
				const formattedDate = `${year}/${month.padStart(2, '0')}/${day.padStart(2, '0')}`;
				return formattedDate === dateStr;
			}
			return false;
		});

		if (matchingDeliveryDate?.title) {
			selectVariantByDate(matchingDeliveryDate.title);
			const isTakeout = window.productMeta?.is_takeout;
			const propertyName = isTakeout ? '受取日' : 'お届け予定日';
			const dateInput = document.querySelector(`input[name="properties[${propertyName}]"]`);
			if (dateInput) {
				dateInput.value = formatDateToJapanese(dateStr);
                dateInput.dispatchEvent(new Event('change', { bubbles: true }));
                window.selectedDate = dateStr;
                updateCartButtonState();
			}
		}
	} catch (error) {
		console.error('Error in changeDate:', error);
	}
}

// バリエーションを日付で選択する関数 (Selects hidden Shopify variant dropdown)
function selectVariantByDate(dateStrYYYYMMDD) {
	if (!dateStrYYYYMMDD || !originalDateSelect || !originalDateSelectOptions) return;
	try {
		const year = dateStrYYYYMMDD.substring(0, 4);
		const month = parseInt(dateStrYYYYMMDD.substring(4, 6), 10);
		const day = parseInt(dateStrYYYYMMDD.substring(6, 8), 10);
        // Always use the "発送予定日：" prefix as confirmed by the user
        const datePrefix = '発送予定日';
		const variantDateText = `${datePrefix}：${year}年${String(month).padStart(2, '0')}月${String(day).padStart(2, '0')}日`;
		// console.log('Looking for variant with date text:', variantDateText); // Remove log
		const options = Array.from(originalDateSelectOptions);
		let found = false;
		for (const option of options) {
			const optionText = option.textContent.trim();
            // Compare the constructed prefixed date string with the actual option text
			if (optionText === variantDateText) {
                if (!option.selected) {
				    option.selected = true;
                    const selectElement = originalDateSelect.querySelector('select'); // Get the actual select element
                    if (selectElement) {
                        selectElement.value = option.value; // Set the select element's value directly
				        selectElement.dispatchEvent(new Event('change', { bubbles: true })); // Trigger change on the select element
                    }
				    // console.log('Selected variant with date text:', variantDateText); // Remove log
                } else {
                    // console.log('Variant already selected:', variantDateText); // Remove log
                }
				found = true;
				break;
			}
		}
		if (!found) {
			// console.warn('No matching variant found for date text:', variantDateText); // Remove warning
            const selectElement = originalDateSelect.querySelector('select');
            if (selectElement) {
                selectElement.selectedIndex = 0; // Reset to default if no match
                selectElement.dispatchEvent(new Event('change', { bubbles: true }));
            }
		}
	} catch (error) {
		console.error('Error selecting variant by date:', error); // Keep error
	}
}

// Fetches product GID
async function getProductId() {
	const url = new URL(window.location.href);
	const jsonURL = `${url.protocol}//${url.hostname}${url.pathname}.json`;
	try {
		const response = await fetch(jsonURL);
        if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
		const data = await response.json();
        if (!data?.product?.id) throw new Error('Invalid product JSON response');
		return `gid://shopify/Product/${data.product.id}`;
	} catch (error) {
		console.error('Error fetching product ID:', error); // Keep error
		return null;
	}
}

 // Fetches prefecture data (only if not takeout)
 async function getPref(productIdStr) {
	window.dispatchEvent(new CustomEvent('loading-start')); // Dispatch loading start
 	// console.log('getPref: Starting prefecture data fetch with product ID:', productIdStr); // Remove log
 	const prefLoadingMessage = document.querySelector('#pref-loading-message');
 	const shippingAreaSelect = document.querySelector('#shippingAreaSelect');
    if (!shippingAreaSelect) {
        // console.warn('Shipping area select element not found in getPref. Skipping fetch.'); // Remove warning
        return null;
    }
	try {
		if (prefLoadingMessage) prefLoadingMessage.style.display = 'block';
		if (!productIdStr) throw new Error('Product ID is required');
		const host = window.ikyuUrls?.otoriyoseUrl || window.location.origin;
		const url = `${host}/apps/multi_suppliers/api/orderable_infos/select_prefectures`;
		// console.log('Fetching prefecture data from:', url); // Remove log
		const response = await fetchWithRetry(url, { // Uses fetchWithRetry
			method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ product_id: productIdStr })
		});
		const data = await response.json();
		// console.log('getPref: Prefecture data fetched successfully:', data); // Remove log
		if (!data || !Array.isArray(data)) throw new Error('Invalid prefecture data format');
		shippingAreaSelect.innerHTML = '';
		const defaultOption = document.createElement('option');
		defaultOption.value = '0';
		defaultOption.textContent = '配送先の都道府県を選択してください';
		shippingAreaSelect.appendChild(defaultOption);
		data.forEach(pref => {
			if (!pref?.is_orderable) return;
			const option = document.createElement('option');
			option.value = pref.province.toString();
			option.textContent = pref.province_name;
			option.dataset.leadtime = pref.leadtime_days.toString();
			shippingAreaSelect.appendChild(option);
		});
		shippingAreaSelect.disabled = false;
		shippingAreaSelect.style.backgroundColor = '#fbfed8';
		const storedValue = localStorage.getItem("myAreaValue");
		let restored = false;
		if (storedValue) {
			const matchingOption = Array.from(shippingAreaSelect.options).find(option => option.value === storedValue);
			if (matchingOption) {
				matchingOption.selected = true;
                restored = true;
                setTimeout(() => {
                    shippingAreaSelect.dispatchEvent(new Event('change', { bubbles: true }));
                    // console.log('Restored previous prefecture selection and dispatched change:', storedValue); // Remove log
                }, 0);
			}
		}
        if (!restored) {
            // console.log('No valid prefecture restored.'); // Remove log
        }
		if (prefLoadingMessage) prefLoadingMessage.style.display = 'none';
		isAsyncGetPrefFinished = true;
		return data;
	} catch (error) {
		console.error('Error in getPref:', error); // Keep error
		if (prefLoadingMessage) prefLoadingMessage.style.display = 'none';
		if (shippingAreaSelect) {
			shippingAreaSelect.disabled = true;
			shippingAreaSelect.innerHTML = '<option value="0">都道府県データの取得に失敗</option>';
		}
		const existingErrorMsg = shippingAreaSelect?.parentNode?.querySelector('.pref-error-message');
        if (!existingErrorMsg) {
            const errorMessage = document.createElement('div');
            errorMessage.className = 'tw-text-red-600 tw-text-center tw-mt-2 pref-error-message';
            errorMessage.textContent = '都道府県データの取得に失敗しました。';
            shippingAreaSelect?.parentNode?.appendChild(errorMessage);
        }
 		throw error;
 	} finally {
		window.dispatchEvent(new CustomEvent('loading-end')); // Dispatch loading end
	} // End try...catch...finally
 } // End getPref

 // Fetches calendar options based on area/takeout
 async function getCalendarOptions(areaValue) {
	window.dispatchEvent(new CustomEvent('loading-start')); // Dispatch loading start
 	// console.log('getCalendarOptions called with area:', areaValue); // Remove log
 	if (!areaValue || (areaValue === "0" && !window.productMeta?.is_takeout)) {
		console.error('Invalid area value for fetching calendar options'); // Keep error
		return null;
	}
	if (!productIdStr) {
		console.error('Product ID is required for fetching calendar options'); // Keep error
		return null;
	}
	const provinceValue = Array.isArray(areaValue) ? areaValue[0] : areaValue;
	const host = window.ikyuUrls?.otoriyoseUrl || window.location.origin;
	const url = `${host}/apps/multi_suppliers/api/orderable_infos/delivery_dates`;
	const requestData = { "product_id": productIdStr, "province": provinceValue };
	// console.log('Calendar options request payload:', JSON.stringify(requestData, null, 2)); // Remove log
	try {
		if (loadingImage) loadingImage.style.display = 'block';
		const response = await fetchWithRetry(url, { // Uses fetchWithRetry
			method: 'POST', headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' }, body: JSON.stringify(requestData)
		});
		const data = await response.json();
		// ★★★ APIレスポンスのログ出力追加 ★★★
		console.log('--- API Response (delivery_dates) ---');
		console.log(JSON.stringify(data, null, 2)); // 整形して出力
		console.log('------------------------------------');
		// ★★★ ログ出力追加ここまで ★★★
		// console.log('Calendar options received:', data); // Remove log
		if (!Array.isArray(data)) throw new Error('Invalid API response format.');
		availableDeliveryDates = data;
		updateCalendarWithAvailableDates(data);
		return data;
	} catch (error) {
		console.error('Error fetching calendar options:', error); // Keep error
		if (loadingImage) loadingImage.style.display = 'none';
		if (window.flatpickrInstance) {
			window.flatpickrInstance.set('disable', [() => true]);
			window.flatpickrInstance.redraw();
 		}
         showCalendar(); // Ensure calendar is shown even on error
         return null;
 	} finally {
		window.dispatchEvent(new CustomEvent('loading-end')); // Dispatch loading end
	}
 } // End getCalendarOptions

// Updates flatpickr instance
function updateCalendarWithAvailableDates(deliveryDates) {
	const flatpickrInstance = window.flatpickrInstance;
	if (!flatpickrInstance) {
		// console.warn('Calendar instance not found'); // Remove warning
		return;
	}
	// console.log('Updating calendar with delivery dates:', deliveryDates); // Remove log
	try {
		if (loadingImage) loadingImage.style.display = 'block';
        if (!Array.isArray(deliveryDates)) {
            // console.warn('Invalid delivery dates data received in updateCalendar'); // Remove warning
            deliveryDates = [];
        }
		const enabledDates = deliveryDates
			// ★★★ 在庫数が0より大きい日付のみをフィルタリングする条件を追加 ★★★
			.filter(item => item?.delivery_date && /^\d{8}$/.test(item.delivery_date) && item.inventoryQuantity > 0)
			.map(item => {
				const year = item.delivery_date.substring(0, 4);
				const month = item.delivery_date.substring(4, 6);
				const day = item.delivery_date.substring(6, 8);
				return `${year}/${month.padStart(2, '0')}/${day.padStart(2, '0')}`;
			});
		// console.log('Enabled dates:', enabledDates); // Remove log
		if (enabledDates.length === 0) {
			flatpickrInstance.set('disable', [() => true]);
			flatpickrInstance.set('enable', []);
            flatpickrInstance.clear();
		} else {
			flatpickrInstance.set('disable', [() => true]);
			flatpickrInstance.set('enable', enabledDates);
			const today = new Date();
			today.setHours(0, 0, 0, 0);
			const sortedDates = enabledDates
				.map(dateStr => parseDate(dateStr))
                .filter(date => date && date >= today)
				.sort((a, b) => a - b);
			if (sortedDates.length > 0) {
				const nearestDate = sortedDates[0];
				const formattedDate = `${nearestDate.getFullYear()}/${addLeadingZero(nearestDate.getMonth() + 1)}/${addLeadingZero(nearestDate.getDate())}`;
				// console.log('Setting nearest available date:', formattedDate); // Remove log
				flatpickrInstance.setDate(formattedDate, true); // true triggers onChange
			} else {
                 flatpickrInstance.clear();
            }
		}
		flatpickrInstance.redraw();
	} catch (error) {
		console.error('Error updating calendar:', error); // Keep error
		flatpickrInstance.set('disable', [() => true]);
		flatpickrInstance.redraw();
	} finally {
		if (loadingImage) loadingImage.style.display = 'none';
	}
}

// Handles area selection change or direct call for takeout
async function whenShippingAreaSelect() {
	// console.log('whenShippingAreaSelect called'); // Remove log
	const isTakeout = window.productMeta?.is_takeout;
	let selectedValue = null;
    if (isTakeout) {
        // console.log('Takeout mode detected, using fixed prefecture code'); // Remove log
        selectedValue = "13"; // Default Tokyo or appropriate logic
    } else {
	    const shippingAreaSelect = document.querySelector('#shippingAreaSelect');
	    if (!shippingAreaSelect) { console.error('Shipping area select element not found'); return; } // Keep error
        selectedValue = shippingAreaSelect.value;
		// console.log('Selected shipping area value:', selectedValue); // Remove log
		if (selectedValue === "0") {
			// console.log('Default prefecture selected, clearing calendar.'); // Remove log
            if (window.flatpickrInstance) {
                window.flatpickrInstance.clear();
                window.flatpickrInstance.set('enable', []);
                window.flatpickrInstance.set('disable', [() => true]);
                window.flatpickrInstance.redraw();
            }
            showCalendar(); // Show the (now disabled) calendar
			return;
		}
    }
	try {
		if (loadingImage) loadingImage.style.display = 'block';
		// console.log('Attempting to fetch calendar options for area:', selectedValue); // Remove log
		await getCalendarOptions(selectedValue); // This updates and potentially sets initial date via onChange

        // --- START: Simplified Visibility Control ---
        // Alpine.js state manipulation removed. Rely on Liquid's x-show and standard JS visibility.
        const calendarContainer = document.getElementById('variant-date-select-wrap');
        const timeContainer = document.querySelector('[data-takeout-time-container]');

        if (isTakeout) {
            // Ensure calendar and time selector are visible for takeout
            // (Liquid's x-show should handle initial visibility, this is a safeguard)
            showCalendar(); // Ensure calendar container is visible
            if (timeContainer) {
                timeContainer.style.display = 'block';
                timeContainer.hidden = false;
                const timeSelect = timeContainer.querySelector('select');
                if (timeSelect) timeSelect.disabled = false; // Ensure time select is usable
                // console.log('Ensured time controls visible and enabled for takeout (in whenShippingAreaSelect)'); // Remove log
            }
        } else {
            // For non-takeout, ensure time container is hidden
            if (timeContainer) {
                timeContainer.style.display = 'none';
                timeContainer.hidden = true;
                // console.log('Hid time container for non-takeout (in whenShippingAreaSelect)'); // Remove log
            }
            // Calendar visibility is handled by Alpine x-show based on area selection
            showCalendar(); // Ensure calendar container is visible after selection
        }
        // --- END: Simplified Visibility Control ---

	} catch (error) {
		console.error('Error in whenShippingAreaSelect:', error); // Keep error
		if (loadingImage) loadingImage.style.display = 'none';
        // Ensure calendar is attempted to be shown even on error, but don't handle time container visibility here on error
        showCalendar(); // Ensure calendar is shown even on error
	}
}

// Shows the calendar container
function showCalendar() {
	const calendarContainer = document.getElementById('variant-date-select-wrap') || document.getElementById('shipping-calendar');
	if (calendarContainer) {
        calendarContainer.style.display = 'block';
        calendarContainer.hidden = false;
		// console.log('Calendar container displayed'); // Remove log
	} else {
        // console.warn('Calendar container not found in showCalendar'); // Remove warning
    }
	// if (loadingImage) console.log('Loading image current display state:', loadingImage.style.display); // Remove log
}

// Sets up listeners for non-date custom options
function setupCustomOptionListeners() {
	// console.log('Setting up custom option change listeners'); // Remove log
	const customOptions = document.querySelectorAll('select[name^="properties["], select[name^="options["]');
	for (const option of customOptions) {
		if (option.id === 'originalDateSelect' || option.closest('[data-takeout-time-container]')) continue;
		option.removeEventListener('change', customOptionChangeHandler); // Prevent duplicates
		option.addEventListener('change', customOptionChangeHandler);
		// console.log(\`Added change listener to option: ${option.name || option.id}\`); // Remove log
	}

    // スライス枚数の選択イベントリスナー
    const sliceSelect = document.querySelector('select[name^="properties[スライス枚数]"]');
    if (sliceSelect) {
        sliceSelect.addEventListener('change', function() {
            updateCartButtonState();
        });
    }
}

// Handles change on non-date custom options
function customOptionChangeHandler(event) {
	// console.log(\`Custom option changed: ${event.target.name || event.target.id}, value: ${event.target.value}\`); // Remove log
    // product-form.js handles the button state update
}

// Enables the shipping area select (if not takeout)
function enableSelect() {
	if (window.productMeta?.is_takeout) return; // Don't enable for takeout

	// console.log('Enabling shipping area select'); // Remove log
	if (shippingAreaSelect) {
		shippingAreaSelect.disabled = false;
		// console.log('Shipping area select enabled'); // Remove log
	} else {
		// console.warn('Shipping area select not found'); // Remove warning
        return;
	}
	if (prefLoadingMessage) prefLoadingMessage.style.display = 'none';

	if (storedValue !== null && storedValue !== "") {
		// console.log('Found stored value:', storedValue); // Remove log
		const options = Array.from(shippingAreaSelect.querySelectorAll('option') || []);
		let storedValueFound = false;
		for (const option of options) {
			if (option.value === storedValue && storedValue !== "0" && !option.disabled) {
				// console.log('Found matching stored area option:', option.text); // Remove log
				option.selected = true;
                // Let the change event triggered by getPref handle subsequent logic
				// setTimeout(() => { shippingAreaSelect.dispatchEvent(new Event('change', { bubbles: true })); }, 0);
				storedValueFound = true;
				break;
			}
		}
		if (!storedValueFound) {
			// console.log('No matching stored value found, resetting to default'); // Remove log
			shippingAreaSelect.selectedIndex = 0;
		}
	} else {
		// console.log('No stored value found'); // Remove log
		shippingAreaSelect.selectedIndex = 0;
	}
}

// Initializes the flatpickr calendar
function initializeCalendar() {
	const calendarContainer = document.getElementById('variant-date-select-wrap') || document.getElementById('shipping-calendar');
	if (!calendarContainer) {
		// console.warn('Calendar container element not found'); // Remove warning
		return;
	}
	// console.log('Initializing calendar'); // Remove log
	try {
		if (loadingImage) loadingImage.style.display = 'block';
		const initialCalendarOptions = {
			inline: true, dateFormat: "Y/m/d", locale: "ja", disableMobile: true, minDate: "today",
			disable: [() => true], enable: [], onChange: changeDate,
			onReady: function(selectedDates, dateStr, instance) {
				if (loadingImage) loadingImage.style.display = 'none';
                // console.log("Flatpickr onReady"); // Remove log
                showCalendar(); // Ensure calendar is shown when ready
			}
		};
		if (window.flatpickrInstance) window.flatpickrInstance.destroy();
		window.flatpickrInstance = flatpickr(calendarContainer, initialCalendarOptions);
		// console.log('Calendar initialized successfully'); // Remove log
	} catch (error) {
		console.error('Error initializing calendar:', error); // Keep error
		if (loadingImage) loadingImage.style.display = 'none';
        showCalendar(); // Ensure calendar container is shown even on error
	} finally {
		if (loadingImage) loadingImage.style.display = 'none';
	}
}

// Removed updateFormState, checkRequiredOptions, forceEnableControls, moveQuantitySelector
// Removed MutationObserver and adjustFormSpacing
